import React from 'react'
import { Activity } from 'lucide-react'
import { Card } from '../ui'

export const SystemStatus = ({ stats }) => {
    return (
        <Card className="border-white/10 bg-primary-500/10 backdrop-blur-md p-6 border-l-4 border-l-primary-500 relative overflow-hidden group">
            <div className="absolute -right-4 -bottom-4 opacity-10 group-hover:scale-110 transition-transform duration-700">
                <Activity className="w-24 h-24 text-primary-400" />
            </div>
            <h4 className="text-xs font-black text-primary-400 uppercase tracking-[0.2em] mb-2">System Status</h4>
            <p className="text-2xl font-bold text-white mb-1">Healthy</p>
            <p className="text-sm text-primary-200/60 font-medium">{stats.total} total processing tokens active</p>
        </Card>
    )
}
